import { formatISO } from 'date-fns'

export const FormatISODate = (value: Date) => {
    let date_string = formatISO(new Date(value));
   
    return  date_string.split("T")[0];
}